<template>
  <div class="banner_countdown_container">
    <div class="banner_countdown" :style="style">
      <span v-if="type === 'beforeBegin'">
        {{ $t('eventRemainTimeToStart', { duration: displayUptoBeginAt }) }}
      </span>
      <span v-if="type === 'beforeEnd'">
        {{ $t('eventRemainTimeToEnd', { duration: displayUptoEndAt }) }}
      </span>
      <span v-if="type === 'ended'">
        {{
          $t('eventRemainTimeToEnd', {
            duration: $t('durationFormat1', { second: 0 }),
          })
        }}
      </span>
    </div>
  </div>
</template>

<script>
import Formatter, { durationMs } from '@/utils/Formatter'

const warnInterval = durationMs.day
const countdownInterval = durationMs.second

export default {
  name: 'banner-countdown',
  props: {
    beginAt: Date,
    endAt: Date,
    baseColor: String,
    fontColor: String,
  },
  data() {
    return {
      /** @type {number | undefined} */
      timerId: undefined,
      /** @type {Date} */
      now: new Date(),
      /** @type {string} */
      type: undefined,
      hurry: false,
    }
  },
  computed: {
    uptoBeginAt() {
      return this.beginAt - this.now
    },
    displayUptoBeginAt() {
      return Formatter.duration(this.uptoBeginAt)
    },
    uptoEndAt() {
      return this.endAt - this.now
    },
    displayUptoEndAt() {
      return Formatter.duration(this.uptoEndAt)
    },
    style() {
      const res = {
        maxWidth: '500px',
        lineHeight: '30px',
        margin: '0 auto',
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: this.hurry ? '#fff' : this.fontColor,
        transition: 'background-color 0.8s, height 0.8s',
        backgroundColor: this.baseColor ? this.baseColor : '#e92252',
        height: '30px',
        overflow: 'hidden',
      }
      if (this.type === 'ended') {
        res.height = '0px'
      }
      if (this.hurry) {
        res.backgroundColor = '#e92252'
      }
      return res
    },
  },
  methods: {
    start() {
      this.countdown()
      this.timerId = setInterval(this.countdown.bind(this), countdownInterval)
    },
    stop() {
      if (this.timerId) clearInterval(this.timerId)
    },
    countdown() {
      this.now = new Date()
      const state = this.getState()
      this.type = state.type
      this.hurry = state.hurry
    },
    getState() {
      const _uptoBeginAt = this.uptoBeginAt
      if (_uptoBeginAt > 0)
        return { type: 'beforeBegin', hurry: _uptoBeginAt < warnInterval }
      const _uptoEndAt = this.uptoEndAt
      if (_uptoEndAt > 0)
        return { type: 'beforeEnd', hurry: _uptoEndAt < warnInterval }
      return { type: 'ended', hurry: true }
    },
  },
  created() {
    // 初期値セット
    this.countdown()
    // カウントダウンタイミングを端末時計の秒針に雰囲気あわせる
    setTimeout(this.start.bind(this), 950 - new Date().getMilliseconds())
  },
  destroyed() {
    this.stop()
  },
}
</script>

<style scoped>
.banner_countdown_container {
  position: relative;
  text-align: center;
}
</style>
